module.exports = __webpack_public_path__ + "img/JX.9e251583.png";